<template>
  <el-form-item
    v-if="visible"
    :label="$t('lang.旋转方向') + '：'">
    <el-select
      v-if="isAir"
      disabled
      :placeholder="$t('lang.请选择')"
      value="" />
    <el-select
      v-else
      :disabled="disabled"
      @change="handleChange"
      :placeholder="$t('lang.请选择')"
      default-first-option
      filterable
      v-model="localValue">
      <el-option
        v-for="i in rotateDirectionOptions"
        :key="'direction_' + i.value"
        :label="i.label"
        :value="i.value" />
    </el-select>
  </el-form-item>
</template>

<script>
export default {
  name: 'RotateDirection',
  props: {
    // v-model 绑定的值
    value: {
      type: [String, Number],
      default: null
    },
    devMode: {
      type: Object,
      default: null
    },
    permissions: {
      type: Array,
      default: () => []
    },
    isAir: {
      type: Boolean,
      default: false
    },
    rotateDirection: {
      type: Array,
      default: () => []
    },
  },
  computed: {
    visible() {
      return this.permissions.includes('ROTATE_DIRECTION');
    },
    disabled() {
      if (this.isAir) return true;
      if (!this.permissions.includes('ROTATE_DIRECTION')) return true;
      return !this.devMode?.motorDirectionChange;
    },
    rotateDirectionOptions() {
      return this.rotateDirection.map(item => ({
        label: this.$t('lang.' + item.name),
        value: item.value
      }));
    },
    localValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    handleChange() {
      this.$emit('change');
    }
  }
};
</script>

